import AccountCenter from './AccountCenter';

export default AccountCenter;



// WEBPACK FOOTER //
// ./src/common/components/account-center/index.jsx